import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRiskMitigationAdvanceControlTableData = createAsyncThunk(
  'alix/risk-mitigation-advance-control-table-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/mitigation/tracker?category=${payload.category}&searchKey=${payload.searchKey}&page=${payload.page}&pageSize=${payload.pageSize}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const updateRiskMitigationAdvanceControlTableData = createAsyncThunk(
  'alix/update-risk-mitigation-advance-control-table-data',
  async (payload, toolkit) => {
    return await AxiosClient('PUT', `/v1/risk-management/mitigation/tracker`, payload, toolkit)
  },
)

export const getActionOwnersList = createAsyncThunk(
  'alix/update-risk-mitigation-action-owners-list',
  async (payload, toolkit) => {
    return await AxiosClient('GET', `v1/risk-management/mitigation/action-owner?clientId=${payload.clientId}`, {}, toolkit)
  },
)
